import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { QuizComponent } from "./quiz/quiz.component";
import { MatComponent } from "./mat/mat.component";
import { PickComponent } from "./pick/pick.component";
import { AllMatComponent } from "./all-mat/all-mat.component";
import { JwtInterceptor } from "./jwt.interceptor";
import { LoginComponent } from "./login/login.component";
import { TrueAnswersComponent } from "./true-answers/true-answers.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { PdfViewerModule } from "@syncfusion/ej2-angular-pdfviewer";
import { NgxDocViewerModule } from 'ngx-doc-viewer'
import { NgHttpLoaderModule } from 'ng-http-loader';
import { ToastrModule } from "ngx-toastr";

@NgModule({
  declarations: [
    AppComponent,
    QuizComponent,
    MatComponent,
    PickComponent,
    AllMatComponent,
    LoginComponent,
    TrueAnswersComponent,
    NavbarComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    PdfViewerModule,
    NgxDocViewerModule,
    NgHttpLoaderModule.forRoot(),
    ToastrModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
